export default __webpack_public_path__ + "static/rbdsbg-a236dd0b3a1c1f681ea6109fa6f01ec4.jpg";